import React, { ComponentType, createContext } from 'react';
import { Subtract } from 'utility-types';

import { SocialAccount } from 'api';

export interface IWithSelectedNetworks {
  selectedNetworks: Array<SocialAccount | string>;
  toggleNetwork: (connection: SocialAccount | string) => void;
}

export const SelectedNetworksContext = createContext<IWithSelectedNetworks>({
  selectedNetworks: [],
  toggleNetwork: () => undefined,
});

export const SelectedNetworksProvider = SelectedNetworksContext.Provider;

export const withSelectedNetworks =
  <T extends IWithSelectedNetworks>(Component: ComponentType<T>) =>
  (props: Subtract<T, IWithSelectedNetworks>) =>
    (
      <SelectedNetworksContext.Consumer>
        {(providerProps: IWithSelectedNetworks) => (
          <Component {...(props as T)} {...providerProps} />
        )}
      </SelectedNetworksContext.Consumer>
    );
